import React from 'react'

import { routing } from '@utils/routing'

import { signets } from '../../assets/signets'
import { AppsIntegrationUnified } from '../AppsIntegrationUnified'
import { AppsMailchimpSettings } from './AppsMailchimpSettings'

export const AppsMailchimp = () => {
  return (
    <AppsIntegrationUnified
      appId="mailchimp"
      name="Mailchimp"
      logoSrc={signets.mailchimpSignet}
      connectDescription="Connect to your Mailchimp account."
      longDescription="Use Mailchimp to sync supporter emails and send custom emails."
      helpCenterUrl={routing.external.helpCenter.mailchimp}
    >
      <AppsMailchimpSettings />
    </AppsIntegrationUnified>
  )
}
